export default "__VITE_ASSET__C$xsm5aS__"